import * as yup from 'yup';
var validateEmailSchema = yup.object().shape({
    email: yup.string().email(),
});
export var isEmailFormatValid = function (email) {
    return validateEmailSchema.isValidSync({
        email: email,
    });
};
